import { Column, Row, RowAlignedItems } from '@components/LinearLayout';
import { P, PBold } from '@components/Typography';
import { Dispatch, SetStateAction } from 'react';
import styled, { useTheme } from 'styled-components';

import Checkbox from '@components/Checkbox';
import { capitalizeFirstLetter } from '@utils/fn';
import { useTranslation } from 'react-i18next';

interface AgendaFilterProps {
  item: {
    id: string;
    title: string;
    values: Array<{
      key: string;
      value: string;
    }>;
  };
  appliedFilters: Record<string, string[]>;
  setAppliedFilters: Dispatch<SetStateAction<Record<string, string[]>>>;
}

export const FilterTitle = styled(PBold)`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
`;

export const AgendaFilterRoot = styled(Column)`
  border-bottom: 0.5rem solid ${({ theme }) => theme.color.lightGrey};
  padding-bottom: 2rem;
`;

export const FilterOptionText = styled(P)`
  color: ${({ theme }) => theme.color.mobilityGrey};
`;

export const OptionsWrapper = styled(Row)`
  flex-wrap: wrap;
`;
const AgendaFilter = ({
  item,
  appliedFilters,
  setAppliedFilters,
}: AgendaFilterProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <AgendaFilterRoot $gap="2rem">
      <FilterTitle>{item.title}</FilterTitle>
      <OptionsWrapper $gap="3rem">
        {[...item.values]
          .sort((a, b) => a.value.localeCompare(b.value))
          .map(({ key, value }) => {
            const getLabel = (value: string, id: string) => {
              if (id === 'job-level') return t(`job-levels.${value}`);
              else if (item.id === 'company-industry')
                return t(`industries.${value}`);
              else return capitalizeFirstLetter(value);
            };

            return (
              <RowAlignedItems key={key}>
                <Checkbox
                  label={
                    <RowAlignedItems>
                      <FilterOptionText>
                        {getLabel(value, item.id)}
                      </FilterOptionText>
                    </RowAlignedItems>
                  }
                  spacing={theme.spacing.size10}
                  checked={appliedFilters[item.id]?.includes(value)}
                  type="square"
                  size="3.2rem"
                  backgroundColor={theme.color.lightGrey}
                  color={theme.color.mobilityGrey}
                  borderRadius={theme.borderRadius.radius5}
                  border="none"
                  onChange={() => {
                    if (appliedFilters?.[item.id]?.includes(value)) {
                      if (appliedFilters?.[item.id]?.length === 1) {
                        const { [item.id]: _, ...rest } = appliedFilters;
                        setAppliedFilters(rest);
                      } else
                        setAppliedFilters({
                          ...appliedFilters,
                          [item.id]: appliedFilters?.[item.id]?.filter(
                            e => e !== value
                          ),
                        });
                    } else {
                      if (appliedFilters?.[item.id]?.length > 0)
                        setAppliedFilters({
                          ...appliedFilters,
                          [item.id]: [
                            ...(appliedFilters?.[item.id] ?? []),
                            value,
                          ],
                        });
                      else
                        setAppliedFilters({
                          ...appliedFilters,
                          [item.id]: [value],
                        });
                    }
                  }}
                />
              </RowAlignedItems>
            );
          })}
      </OptionsWrapper>
    </AgendaFilterRoot>
  );
};

export default AgendaFilter;
